var map = {
	"./Deloittelogo.png": 9392,
	"./Igloofestlogo.png": 7260,
	"./Intact logo.png": 8759,
	"./MAD festival Logo.webp": 2230,
	"./Montreal logo.jpg": 8810,
	"./Moxy-Hotels-logo.png": 2760,
	"./Pikniclogo.jpeg": 9531,
	"./Prada logo.webp": 6280,
	"./SIM logo.jpg": 9007,
	"./Summit-logo.png": 2950,
	"./The-Home-Depot-Logo.jpg": 7375,
	"./Tims good logo.webp": 670,
	"./Ubisoft-Logo.wine.png": 8958,
	"./courtyard-by-marriott-1-logo-png-transparent.png": 5500,
	"./holiday-inn-14-logo-png-transparent.png": 642,
	"./leyad logo.png": 2831,
	"./rona-logo.png": 5483,
	"./wendys-logo.png": 9063,
	"./windsor_logo_invitation (1).jpg": 3441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8331;